import { useState, useCallback, useRef } from "react";

// Shared multi-select: toggle, select-all, and shift-click range selection.
export function useRowSelection() {
  const [selected, setSelected] = useState(() => new Set());
  const lastIndex = useRef(null);

  const toggle = useCallback((id, index, shiftKey, orderedIds) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (shiftKey && lastIndex.current != null && orderedIds && index != null) {
        const anchorSelected = prev.has(orderedIds[lastIndex.current]);
        const [a, b] = [lastIndex.current, index].sort((x, y) => x - y);
        for (let i = a; i <= b; i++) {
          if (anchorSelected) next.add(orderedIds[i]);
          else next.delete(orderedIds[i]);
        }
      } else {
        next.has(id) ? next.delete(id) : next.add(id);
      }
      return next;
    });
    lastIndex.current = index;
  }, []);

  const selectAll = useCallback((ids) => {
    setSelected((prev) => (prev.size === ids.length && ids.length > 0 ? new Set() : new Set(ids)));
  }, []);

  const clear = useCallback(() => { setSelected(new Set()); lastIndex.current = null; }, []);
  const isSelected = useCallback((id) => selected.has(id), [selected]);

  return { selected, ids: [...selected], count: selected.size, toggle, selectAll, clear, isSelected };
}
